import React from "react";
import PropTypes from "prop-types";

import LogdevGraph from "./LogdevGraph";
import TimeRange from "../../../Components/TimeRange";

import "./GraphContainer.scss";

const GraphContainer = (props) => {
  const { graphData, graphParams, graphTitle, windowEnd, windowStart } = props;

  return (
    <div className="resources-graph">
      <div className="resources-graph-title">
        <div className="title-main">{graphTitle}</div>

        <TimeRange dateStart={windowStart} dateEnd={windowEnd} prefix="" />
      </div>

      <LogdevGraph data={graphData} graphParams={graphParams} />
    </div>
  );
};

GraphContainer.propTypes = {
  graphData: PropTypes.arrayOf(PropTypes.shape({})),
  graphParams: PropTypes.shape({}),
  graphTitle: PropTypes.string,
  windowEnd: PropTypes.string,
  windowStart: PropTypes.string,
};

GraphContainer.defaultProps = {
  graphData: {},
  graphParams: {},
  graphTitle: "",
  windowEnd: "",
  windowStart: "",
};

export default GraphContainer;
